<script setup lang="ts">
import { computed } from "vue";
import { formatCurrency } from "@/composables/formatCurrency";

const props = defineProps<{
    totalAnnualPension: number;
}>();

const annualIncome = computed(() => {
    return formatCurrency(props.totalAnnualPension, 2);
});
</script>

<template>
    <div
        class="result-annual"
    >
        <p class="result-annual-label">
            Annual income
        </p>
        <p class="result-annual-value">
            {{ annualIncome }}
        </p>
    </div>
</template>

<style scoped>
.result-annual {
    display: flex;
    flex-direction: column;
    margin: 16px;
    text-align: center;
}

.result-annual-label,
.result-annual-value {
    margin: 0;
    font-weight: 600;
    font-size: 18px;
    text-transform: none;
}
</style>
